import styled from "styled-components";
import { colors } from "../../../theme/theme";

export const EmptyWrapper = styled.div`
	margin: 1em auto;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	place-self: center;
	justify-self: center;
	align-self: center;
	gap: 36px;
	font-size: 24px;
	color: ${colors.greyscale.grey};
`;
